const styles = {
  container: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
  },
  close: {
    position: 'absolute',
    right: 0,
    top: -3,
  },
  image: {
    // objectFit: 'contain' as const,
    height: '100%',
    width: '100%',
    minWidth: 444,
  },
  title: {
    fontSize: 16,
    textAlign: 'center',
    fontWeight: '600',
    color: 'primary.main',
    my: '8px',
  },
  endText: {
    textAlign: 'center',
    fontSize: 14,
    mb: '12px',
  },
  closeIcon: {
    color: 'common.grey350',
    margin: '5px',
    padding: '3px',
  },
};

export default styles;
